import { Component, HostListener } from '@angular/core';
import { SharedLanguageService } from '@language';
import { DialogConfig, DialogRef } from '@stylehaven/components';

export type BatchTagDialogResult = {
    dialogResult: boolean;
    batchTag?: string;
};

@Component({
    selector: 'mhv-batch-tag-dialog-component',
    templateUrl: './batch-tag-dialog.component.html'
})
export class BatchTagDialogComponent {
    batchTag: string;

    constructor(
        public config: DialogConfig,
        public dialog: DialogRef<BatchTagDialogResult>,
        public translateService: SharedLanguageService
    ) {
        config.data.message = this.translateService.translate('batches.start-batch-dialog.message');
        config.data.batchTagDialogMessage = this.translateService.translate('batches.batch-tag-dialog');
    }

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        this.yes();
    }

    yes(): void {
        this.dialog.close({ dialogResult: true, batchTag: this.batchTag });
    }

    no(): void {
        this.dialog.close({ dialogResult: false });
    }
}
